import { Heading, Loader } from "@/components";
import useHelpDocument from "./useHelpDocument";
import NoData from "@/assets/noData.svg";

const HelpDocument = () => {
  const {isLoadingHelpDocument,
    isAttachmentLoading,
    attachment} = useHelpDocument();

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <Heading title={"Help Document"} />
      </div>

      <div className="mt-[20px]">
        {isLoadingHelpDocument || isAttachmentLoading ?
          <Loader /> :
          attachment?.data ? 
            <iframe src={attachment?.data} className="h-[calc(100vh-170px)] w-full bg-white" /> : 
            <div className="flex flex-col items-center justify-center">
              <img src={NoData} className="w-[400px] h-auto" />
            </div>
        }
      </div>
    </div>
  )
}

export default HelpDocument;